import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=4986c9d2&scoped=true&"
import script from "./DeliveryList.vue?vue&type=script&lang=js&"
export * from "./DeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=4986c9d2&scoped=true&lang=less&"
import style1 from "./DeliveryList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986c9d2",
  null
  
)

export default component.exports